import { PlusOutlined } from '@ant-design/icons';
import { ServiceSelect } from '@components';
import { L } from '@lib';
import { Button, Col, Row, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface IProps {
  service?: number | number[];
  cleanName?: boolean;
  required?: boolean;
  serviceTitle?: string;
  onSelect?: (value: number) => void;
  onAddClick?: React.MouseEventHandler<HTMLElement> | undefined;
  onClear?: () => void;
}

export const ServiceAddSelect: React.FC<IProps> = ({
  service,
  cleanName,
  serviceTitle = 'Service name',
  required = false,
  onSelect,
  onAddClick,
  onClear,
}) => {
  return (
    <>
      <Row justify="space-between">
        <Col>
          {serviceTitle && (
            <Text>
              <Text strong style={{ color: '#ff4d4f' }}>
                *
              </Text>{' '}
              {L(serviceTitle)}
            </Text>
          )}
        </Col>
        <Col>
          <Button icon={<PlusOutlined />} type="link" onClick={onAddClick}>
            New service
          </Button>
        </Col>
      </Row>
      <ServiceSelect
        value={service}
        cleanName={cleanName}
        status={required ? 'error' : undefined}
        onSelect={onSelect}
        onClear={onClear}
      />

      {required && <Text style={{ color: 'red' }}>{L('Required')}</Text>}
      <br />
      <br />
    </>
  );
};
